import { render, staticRenderFns } from "./dashboardIndex.vue?vue&type=template&id=4182cfb8&scoped=true"
import script from "./dashboardIndex.vue?vue&type=script&lang=js"
export * from "./dashboardIndex.vue?vue&type=script&lang=js"
import style0 from "./dashboardIndex.vue?vue&type=style&index=0&id=4182cfb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4182cfb8",
  null
  
)

export default component.exports